module.exports = __webpack_public_path__ + "static/media/6306.1bfe44ce.svg";